<div class="breadcrumb">
    <ng-container *ngFor="let link of breadcrumbs; let last = last">
        <a class="link"
           [routerLink]="link?.url"
           *ngIf="!last">{{ link?.title }}</a>
        <span *ngIf="!last" aria-hidden="true" style="font-family:monospace"> > </span>
        <span class="last" *ngIf="last">{{ link?.title }}</span>
    </ng-container>
</div>
